import { render, staticRenderFns } from "./GravarContatoRealizadoDialog.vue?vue&type=template&id=bef513fe&scoped=true&"
import script from "./GravarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
export * from "./GravarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
import style0 from "./GravarContatoRealizadoDialog.vue?vue&type=style&index=0&id=bef513fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef513fe",
  null
  
)

export default component.exports